<template>
  <div class="g-lst">
    <avl-games-list-item
      class="g-lst__item"
      v-for="game in games"
      :key="game.id"
      :game="game"
    ></avl-games-list-item>
  </div>
</template>

<script>
  import GamesListItem from './games-list-item';

  export default {
    props: {
      games: {
        type: Array,
        required: true,
      },
      totalGames: {
        type: Number,
        required: true,
      },
    },
    components: {
      'avl-games-list-item': GamesListItem,
    },
  };
</script>

<style scoped lang="scss">
  .g-lst {
    text-align: center;
    margin: 0 auto;
    //
    width: 312px;
    @include tablet-lg() {
      width: 780px;
    }
  }
</style>
